<template>
  <div class="favorites-page">
    <div class="page-container">
      <div class="user-center">
        <user-center-sidebar active="favorites" :user-info="userInfo"></user-center-sidebar>

        <!-- 主内容区 -->
        <section class="user-main">
          <!-- 统计卡片 -->
          <!-- <div class="stats-grid">
            <div class="stat-card">
              <div class="stat-icon"><i class="el-icon-monitor"></i></div>
              <div>
                <div class="stat-num">{{ siteFavorites.length }}</div>
                <div class="stat-label">收藏网址</div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon"><i class="el-icon-mobile-phone"></i></div>
              <div>
                <div class="stat-num">{{ h5Favorites.length }}</div>
                <div class="stat-label">收藏H5</div>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-icon"><i class="el-icon-star-on"></i></div>
              <div>
                <div class="stat-num">{{ favorites.length }}</div>
                <div class="stat-label">总计</div>
              </div>
            </div>
          </div> -->

          <!-- 网址收藏 -->
          <div class="user-card" v-loading="loading">
            <div class="card-title">
              <h2>网址收藏</h2>
              <div class="card-actions">
                <span class="extra">来自供应链网站大全</span>
                <el-button size="small" @click="$router.push('/websiteDirectory')">
                  <i class="el-icon-monitor"></i> 去看更多网址
                </el-button>
              </div>
            </div>
            <div class="filter-bar">
              <el-input
                v-model.trim="keyword"
                clearable
                prefix-icon="el-icon-search"
                placeholder="按平台名称或说明搜索"
              ></el-input>
            </div>
            <div class="fav-list" v-if="filteredSiteFavorites.length > 0">
              <div class="fav-item" v-for="fav in filteredSiteFavorites" :key="fav.id">
                <div class="fav-thumb">
                  <i class="el-icon-monitor"></i>
                </div>
                <div class="fav-meta">
                  <div class="fav-name">{{ fav.name }}</div>
                  <div class="fav-desc">{{ fav.desc || fav.url || '暂无描述' }}</div>
                </div>
                <div class="fav-actions">
                  <span class="fav-time">{{ formatTime(fav.savedAt) }}</span>
                  <a :href="fav.url" target="_blank" rel="noopener" class="fav-link">打开</a>
                  <el-button type="danger" size="mini" text @click="handleRemoveFav(fav)">取消收藏</el-button>
                </div>
              </div>
            </div>
            <div class="empty" v-else>
              <i :class="keyword ? 'el-icon-search' : 'el-icon-inbox'"></i>
              {{ keyword ? '未找到匹配的收藏' : '暂无收藏' }}
            </div>
          </div>

          <!-- H5名片收藏 -->
          <!-- <div class="user-card">
            <div class="card-title">
              <h2>H5名片收藏</h2>
              <span class="extra">来自 H5资源管理</span>
            </div>
            <div class="fav-list" v-if="h5Favorites.length > 0">
              <div class="fav-item" v-for="fav in h5Favorites" :key="fav.id">
                <div class="fav-thumb">
                  <i class="el-icon-mobile-phone"></i>
                </div>
                <div class="fav-meta">
                  <div class="fav-name">{{ fav.name }}</div>
                  <div class="fav-desc">{{ fav.desc || '暂无描述' }}</div>
                </div>
                <div class="fav-actions">
                  <span class="fav-time">{{ formatTime(fav.savedAt) }}</span>
                  <el-button type="danger" size="mini" text @click="handleRemoveFav(fav)">取消收藏</el-button>
                </div>
              </div>
            </div>
            <div class="empty" v-else>
              <i class="el-icon-inbox"></i> 暂无收藏
            </div>
          </div> -->
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentUser, formatTime } from '@/utils/auth'
import UserCenterSidebar from '@/components/UserCenterSidebar'

export default {
  name: 'Favorites',
  components: {
    UserCenterSidebar
  },
  data () {
    return {
      userInfo: {},
      favorites: [],
      loading: false,
      keyword: ''
    }
  },
  computed: {
    siteFavorites () {
      return this.favorites.map(fav => {
        const site = fav.supplyChainSite || {}
        return {
          id: fav.id,
          name: site.name || fav.targetTitle || '',
          desc: site.description || fav.targetSubtitle || '',
          url: site.siteUrl || fav.targetUrl || '',
          savedAt: fav.createTime || ''
        }
      })
    },
    filteredSiteFavorites () {
      const keyword = this.keyword.toLowerCase()
      if (!keyword) return this.siteFavorites

      return this.siteFavorites.filter(fav => {
        return [fav.name, fav.desc].some(value => String(value || '').toLowerCase().includes(keyword))
      })
    }
  },
  created () {
    this.$bus.$on('login-success', this.handleLoginSuccess)
    if (!this.checkLogin()) return
    this.loadData()
  },
  methods: {
    checkLogin () {
      const user = getCurrentUser()
      if (!user) {
        this.$bus.$emit('open-login')
        return false
      }
      this.userInfo = user
      return true
    },
    handleLoginSuccess () {
      if (!getCurrentUser()) return
      this.checkLogin()
      this.loadData()
    },
    loadData () {
      this.loading = true
      this.$http({
        url: this.$http.adornUrl('/crmapi/crm/favorite/list'),
        method: 'post',
        data: this.$http.adornData({
          data: { source: 'SUPPLY_CHAIN_SITE' },
          params: {}
        })
      }).then(({ data }) => {
        if (data && data.code === 'C0000') {
          const result = data.result || {}
          this.favorites = result.list || []
        } else {
          this.$message.error((data && data.message) || '获取收藏列表失败')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    formatTime (time) {
      return formatTime(time)
    },
    handleRemoveFav (fav) {
      this.$confirm('确定要取消收藏吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/crmapi/crm/favorite/del'),
          method: 'post',
          data: this.$http.adornData({ id: fav.id })
        }).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message.success('已取消收藏')
            this.loadData()
          } else {
            this.$message.error((data && data.message) || '取消收藏失败')
          }
        })
      }).catch(() => {})
    }
  },
  beforeDestroy () {
    this.$bus.$off('login-success', this.handleLoginSuccess)
  }
}
</script>

<style lang="scss" scoped>
.favorites-page {
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
}

.page-container {
  max-width: 1200px;
  margin: 0 auto;
}

.user-center {
  display: flex;
  gap: 20px;
}

.user-main {
  flex: 1;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;

  .stat-card {
    background: #fff;
    border-radius: 12px;
    padding: 24px;
    display: flex;
    align-items: center;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

    .stat-icon {
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;

      i {
        font-size: 24px;
        color: #ff9800;
      }
    }

    .stat-num {
      font-size: 24px;
      font-weight: 600;
      color: #333;
    }

    .stat-label {
      font-size: 13px;
      color: #999;
    }
  }
}

.user-card {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

  .card-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid #f0f0f0;

    h2 {
      font-size: 16px;
      color: #333;
      margin: 0;
    }

    .extra {
      font-size: 13px;
      color: #999;
    }

    .card-actions {
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }
}

.fav-list {
  padding: 8px 24px 16px;

  .fav-item {
    display: flex;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: none;
    }

    .fav-thumb {
      width: 48px;
      height: 48px;
      background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;

      i {
        font-size: 22px;
        color: #4caf50;
      }
    }

    .fav-meta {
      flex: 1;
      min-width: 0;

      .fav-name {
        font-size: 15px;
        color: #333;
        font-weight: 500;
        margin-bottom: 4px;
      }

      .fav-desc {
        font-size: 13px;
        color: #999;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .fav-actions {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;

      .fav-time {
        font-size: 12px;
        color: #ccc;
      }

      .fav-link {
        font-size: 13px;
        color: #667eea;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.filter-bar {
  padding: 16px 24px 0;

  .el-input {
    max-width: 320px;
  }
}

.empty {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;

  i {
    font-size: 40px;
    color: #ddd;
    display: block;
    margin-bottom: 12px;
  }
}

@media screen and (max-width: 768px) {
  .user-center {
    flex-direction: column;
  }

  .stats-grid {
    grid-template-columns: 1fr;
  }

  .filter-bar .el-input {
    max-width: none;
  }

  .fav-list .fav-item {
    flex-direction: column;
    align-items: flex-start;

    .fav-thumb {
      margin-bottom: 12px;
    }

    .fav-meta {
      width: 100%;
      margin-bottom: 12px;
    }

    .fav-actions {
      width: 100%;
      justify-content: flex-end;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/favorites.vue